import React from 'react';
import MyMuses from '../domains/muses/components/MyMuses';
import { MyMusesProps } from '../types';

const MyMusesPage: React.FC<MyMusesProps> = ({ onMuseSelect }) => {
  return <MyMuses onMuseSelect={onMuseSelect} />;
};

export default MyMusesPage; 